import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { ModalCloseButton as m } from "./ModalCloseButton.js";
import { Header as d, Title as i } from "../styles.js";
const p = ({ children: r, className: e }) => /* @__PURE__ */ t(d, { className: e, children: [
  /* @__PURE__ */ o(i, { children: r }),
  /* @__PURE__ */ o(m, {})
] });
export {
  p as ModalHeader
};
//# sourceMappingURL=ModalHeader.js.map
